<div class="container mx-auto p-2">
    <div class="text-2xl text-center my-4 text-gray-800" style="text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.5);">Regional
        Outputs</div>

    <div class="bg-green-50 border border-green-200 rounded-lg p-4 my-4 shadow-md">
        <p class="text-gray-700 font-medium">
            In this page, the map displays the European Union's NUTS 2 subdivisions, similar to <a
                href="https://www.mapchart.net/europe-nuts2.html"><u class="text-blue-600">this</u></a>.
            You can see each subdivision's NUTS code and name by hovering over it with the cursor. <br> <br>
            In order to calculate the regional outputs, simply select a NUTS2 region by clicking it on the map. Then you
            need to enter the <strong>current</strong> and <strong>target proportions of arable land under organic
                farming</strong>, using 2 <strong></strong>using 2 <u>slider bars</u> (%) and finally click on
            <strong>Calculate NCPs</strong>. <br> <br>
        </p>
    </div>
    <div class="text-gray-600 italic text-center mb-4">
        Details on the outputs are provided below.
    </div>

    <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div class="space-y-4">
            <div class="bg-white rounded-lg shadow-md p-4">
                <div class="text-xl mb-4" style="text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.5);">
                    Spider (Radar) Chart
                </div>
                <div class="ml-2">Displays standardised average biophysical values. Currently supported NCPs:</div>
                <div class="ml-2 mt-2">
                    <div class="text-lg" style="text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.5);">
                        Soil Organic Carbon
                    </div>
                    <div class="ml-2">Soil organic carbon is the amount of carbon in the soil for a defined depth and
                        area. Carbon stored in the soil is not emitted as CO2 to the atmosphere and promotes climate
                        change mitigation. <strong>Robustness</strong>: <span class="ml-2 text-green-600">High</span>
                    </div>
                </div>
                <div class="ml-2 mt-2">
                    <div class="text-lg" style="text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.5);">
                        Hydraulic Conductivity
                    </div>
                    <div class="ml-2">The hydraulic conductivity determines how fast the water moves through the soil.
                        When this is fast, the risk of flooding and runoff is lower. <strong>Robustness</strong>: <span
                            class="ml-2 text-yellow-600">Medium</span></div>
                </div>
                <div class="ml-2 mt-2">
                    <div class="text-lg" style="text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.5);">
                        Yield
                    </div>
                    <div class="ml-2">The yield is the dry weight at crop's harvest. <strong>Robustness</strong>: <span
                            class="ml-2 text-red-600">Low</span></div>
                </div>
            </div>
        </div>
        <div class="space-y-4">
            <div class="bg-white rounded-lg shadow-md p-4">
                <div class="text-xl mb-4" style="text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.5);">Line Chart</div>
                <div class="ml-2">Shows NCPs as a function of proportion arable land converted from conventional to
                    organic.</div>
            </div>
            <div class="bg-white rounded-lg shadow-md p-4">
                <div class="text-xl mb-4" style="text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.5);">Density Plot</div>
                <div class="ml-2">Shows NCP output distribution for a particular proportion of arable land.</div>
            </div>
            <div class="bg-white rounded-lg shadow-md p-4">
                <div class="text-xl mb-4" style="text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.5);">Table</div>
                <div class="ml-2">All NCP outputs in a common table.</div>
            </div>
        </div>
    </div>